export const ChartEvent = {
  ApiResponsed: 'chart_api_responsed',
  TimeframeClick: 'chart_timeframe_click',
  CandlesSelectClick: 'chart_candles_select_click',
  IndicatorClick: 'chart_indicator_click',
  IndicatorManageClick: 'chart_indicator_manage_click',
  DisplayModeClick: 'chart_display_mode_click',
  SnapshotSelectClick: 'chart_snapshot_select_click',
  ScreenExpandClick: 'chart_screen_expand_click',
  PercentageClick: 'chart_percentage_click',
  AutoClick: 'chart_auto_click',
  ChartEventToggleClick: 'chart_event_toggle_click',
  IndicatorRemoved: 'chart_indicator_removed',
  ChartIdentifierClick: 'chart_identifier',
} as const;

export interface ChartDataType {
  [ChartEvent.ApiResponsed]: {
    api_url: string;
    is_last: boolean;
    cf_cache_status: string;
  };
  [ChartEvent.TimeframeClick]: {
    interval: string;
  };
  [ChartEvent.CandlesSelectClick]: {};
  [ChartEvent.IndicatorClick]: {};
  [ChartEvent.IndicatorManageClick]: {
    value: string;
  };
  [ChartEvent.DisplayModeClick]: {
    value: string;
  };
  [ChartEvent.SnapshotSelectClick]: {
    value: string;
  };
  [ChartEvent.ScreenExpandClick]: {};
  [ChartEvent.PercentageClick]: {};
  [ChartEvent.AutoClick]: {};
  [ChartEvent.ChartEventToggleClick]: {
    event_name: string;
    action: 'turn_on' | 'turn_off';
  };
  [ChartEvent.IndicatorRemoved]: {
    indicator_id: string;
    indicator_name?: string;
  };
  [ChartEvent.ChartIdentifierClick]: {};
}
